import { render } from "./DashboardPage.vue?vue&type=template&id=2d8d440a&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=2d8d440a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3657311707/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8d440a"]])

export default __exports__